import { bool, object, string, func, oneOfType, arrayOf } from 'prop-types'
import Div from '@ui/layout/Div'
import Alert from '@ui/elements/Alert'
import Buttons from '@ui/elements/Buttons'

const CheckboxType = ({
  name,
  onClick = () => { },
  options = [],
  cssClass,
  canCreate,
  creationModalCaller,
  label = false,
  help = false,
  isMultiple = false,
  value = '',
  error
}) => {
  const checkedOptions = isMultiple && value ? value.split(',') : []

  const updateCallback = (e, optionValue) => {
    let updatedValue = e.target.checked ? optionValue : ''

    if (isMultiple) {
      if (e.target.checked) {
        updatedValue = !value ? String(optionValue) : `${value},${optionValue}`
      } else {
        updatedValue = checkedOptions.filter(element => parseInt(element) !== optionValue).join(',')
      }
    }

    onClick(name, updatedValue)
  }

  const isOptionChecked = option => {
    if (isMultiple) {
      return checkedOptions.indexOf(String(option.value)) >= 0
    } else {
      return option.checked
    }
  }

  const renderOptionChilds = option => {
    return option.childs.map(child => {
      return <li key={`sub-opt-${child.value}-${child.label}`}>{renderOption(child, 'sub-opt')}</li>
    })
  }

  const renderOption = (option, cssClass = 'main-opt') => {
    return (
      <label className={`checkbox ${cssClass}`} htmlFor={`input-${name}`} key={`${option.value}-${option.label}`}>
        <input type="checkbox" id={`input-${name}`} name={name} onClick={e => updateCallback(e, option.value)} checked={isOptionChecked(option)} value={option.value} onChange={() => { }} />
        {option.label}
      </label>
    )
  }

  const renderOptions = options.map(option => {
    return (
      <Div cssClass='checkbox-col' key={`${option.label}-${name}-${option.value}`}>
        {renderOption(option)}
        {typeof option.childs !== 'undefined' && option.childs.length ? <ul className='sub-opts'> {renderOptionChilds(option)} </ul> : ''}
      </Div>
    )
  })

  return (
    <Div cssClass={`field ${cssClass}`}>
      {label && <label className="label">{label}</label>}

      <Div cssClass="control">
        {renderOptions}
        {canCreate ? <Buttons buttons={{ icon: 'icon-add_circle', callback: creationModalCaller }} /> : <></>}
      </Div>
      {help && <p className="help">{help}</p>}
      {error && <Alert cssClass='clear' type='is-danger' message={error} />}
    </Div>
  )
}

CheckboxType.propTypes = {
  name: string,
  onClick: func,
  cssClass: string,
  canCreate: bool,
  creationModalCaller: func,
  options: oneOfType([arrayOf(object), object]),
  help: bool,
  label: string,
  isMultiple: bool,
  value: string,
  error: string
}

export default CheckboxType
